module.exports = __webpack_public_path__ + "img/logo_w.6ea398fe.png";